import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=18fed82a&"
import script from "./Revenue.vue?vue&type=script&lang=babel&"
export * from "./Revenue.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports